export default "__VITE_ASSET__Dhtypkz0__"